"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNilOrEmpty = void 0;
const ramda_1 = require("ramda");
exports.isNilOrEmpty = (0, ramda_1.anyPass)([ramda_1.isNil, ramda_1.isEmpty]);
